import get from 'lodash/get';
import { modify } from "mythil/object";
import { isAuthenticated, getParentId, getCurrentModelId } from "~/stateGetter";
import isModelNavigation from "~/navigation/helpers/isModelNavigation";

const ROUTER_LOCATION_CHANGED = 'ROUTER_LOCATION_CHANGED';
const ROUTER_GO_BACK = 'ROUTER_GO_BACK';
const ROUTER_POP = 'ROUTER_POP';

export default function reduceRouter (state, action) {
    const { page, appPage } = state.router.result ?? {};

    switch (action.type) {
        case ROUTER_LOCATION_CHANGED: 
            state = modify(state, "router.goBackOptions", undefined);
            break;
        case ROUTER_GO_BACK:
            state = modify(state, "router.goBackOptions", get(action, "payload.options"))
            break;
        case ROUTER_POP:
            state = modify(state, "router.goBackOptions", (options) => options ?? ({
                forceChangeRootModel: isModelNavigation(action.payload.result.type) && !getParentId(state, getCurrentModelId(state))
            }));
            break;
    }

    if (state.appPage !== 'auth') {
        return state;
    }

    state = modify(state, 'page', (previous) => {
        if (page) return page;
        return previous;
    });

    state = modify(state, 'appPage', (previous) => {
        if (appPage) return appPage;
        if (!isAuthenticated(state)) return 'auth';
        return previous;
    });

    return state;
}